/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ServiceOrderPaidRequest } from '../types/ServiceOrderPaid';
import type { ServiceOrderListResponse } from '../types/ServiceOrderList';

export type ServiceOrdersPaidCreateRequest = ServiceOrderPaidRequest;
export type ServiceOrdersPaidCreateResponse = ServiceOrderListResponse;

export type ServiceOrdersPaidCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this service order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/service_orders/{id}/paid/
 *
 * ```yaml
 * operationId: service_orders_paid_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderPaid'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderPaid'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderPaid'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersPaidCreateOperation = ({ id, ...rest }: ServiceOrdersPaidCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/service_orders/${id}/paid/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/service_orders/{id}/paid/' };
  };

/**
 * POST /dmx-server/service_orders/{id}/paid/
 *
 * ```yaml
 * operationId: service_orders_paid_create
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderPaid'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderPaid'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ServiceOrderPaid'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersPaidCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ServiceOrdersPaidCreateQuery;
  request: ServiceOrderPaidRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ServiceOrderListResponse>> => {
  const operation = serviceOrdersPaidCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
